import { NOTIFICATION_SETTINGS_PATH } from './routePaths';

export const routes = {
  [NOTIFICATION_SETTINGS_PATH]: {
    path: NOTIFICATION_SETTINGS_PATH,
    displayName: 'Notifications & Settings',
    breadcrumbBackUrl: '/',
    description: 'Manage Notifications',
    featureFlag: 'shouldShowNotificationSettingsTab'
  }
};

export default routes;
